import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tools-changelang',
  templateUrl: './tools-changelang.component.html',
  styleUrls: ['./tools-changelang.component.scss']
})
export class ToolsChangelangComponent implements OnInit {

  constructor(
    public translate: TranslateService) {
      // translate.addLangs(['en', 'es', 'fr', 'zh']);
      // translate.setDefaultLang('en');
    }

    browserLang: string;
    // @Output() langEmit = new EventEmitter<string>();
    
  ngOnInit(): void {
    if(localStorage.getItem('lang')){
      this.chooseLang(localStorage.getItem('lang') != "undefined"?localStorage.getItem('lang'): 'en');
    } else {
      this.getSubdomain();
    }
    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   // console.log(event.lang);
    //   this.chooseLang(event.lang);
    // });
  }

  chooseLang(selected: any) {
    console.log(selected);
    this.browserLang = selected;
    this.translate.use(this.browserLang);
    // this.translate.setTranslation(this.browserLang, defaultLanguage);
    // this.langEmit.emit(this.browserLang);
    localStorage.setItem('lang', this.browserLang);
  }

  getSubdomain(): void {
    const domain = window.location.hostname;
    // console.log(domain.split('.'));
    // let splitd = domain.split('.')
    const split1 = domain.split('.')[0];
    const split2 = domain.split('.')[domain.split('.').length - 1];
    // console.log(domain.split('.')[domain.split('.').length - 1]);


    if (split1 === 'cn' || split2 === 'cn') {
      this.browserLang = 'zh';
      this.translate.use(this.browserLang.match(/en|es|fr|zh/) ? this.browserLang : 'zh');
    } else if (split1 === 'es') {
      this.browserLang = 'es';
      this.translate.use(this.browserLang.match(/en|es|fr|zh/) ? this.browserLang : 'es');
    } else if (split1 === 'fr') {
      this.browserLang = 'fr';
      this.translate.use(this.browserLang.match(/en|es|fr|zh/) ? this.browserLang : 'fr');
    } else {
      this.browserLang = 'en';
      this.translate.use(this.browserLang.match(/en|es|fr|zh/) ? this.browserLang : 'en');
    }
    localStorage.setItem('lang', this.browserLang);
    // console.log('subdomain', split1, split2);
    // console.log('browserlang', this.browserLang);
  }

}
